import { render, staticRenderFns } from "./Brackets.vue?vue&type=template&id=273c90a5&"
import script from "./Brackets.vue?vue&type=script&lang=js&"
export * from "./Brackets.vue?vue&type=script&lang=js&"
import style0 from "./Brackets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports